// Cloudinary configuration
export const cloudinaryConfig = {
  cloudName: 'dpdv8xcah',
  apiKey: process.env.REACT_APP_CLOUDINARY_API_KEY || '',
  apiSecret: process.env.REACT_APP_CLOUDINARY_API_SECRET || '',
  // Upload preset name - should be set in environment variable or create in Cloudinary dashboard
  uploadPreset: process.env.REACT_APP_CLOUDINARY_UPLOAD_PRESET || 
                process.env.REACT_APP_CLOUDINARY_PRESET || 
                'studystay_upload'
};

// Helper function to build Cloudinary URLs
export const buildCloudinaryUrl = (publicId, options = {}) => {
  const {
    width = 'auto',
    height = 'auto',
    crop = 'fill',
    quality = 'auto',
    format = 'auto'
  } = options;

  // If publicId is already a full URL, return it as is
  if (publicId && (publicId.includes('http') || publicId.includes('cloudinary.com'))) {
    return publicId;
  }

  // Clean the publicId (remove any existing transformations)
  let cleanPublicId = publicId;
  if (cleanPublicId && cleanPublicId.includes('/image/upload/')) {
    const parts = cleanPublicId.split('/image/upload/');
    if (parts.length > 1) {
      cleanPublicId = parts[1];
    }
  }

  return `https://res.cloudinary.com/${cloudinaryConfig.cloudName}/image/upload/w_${width},h_${height},c_${crop},q_${quality},f_${format}/${cleanPublicId}`;
};

// Helper function to get optimized image URL
export const getOptimizedImageUrl = (publicId, width = 800, height = 600) => {
  return buildCloudinaryUrl(publicId, {
    width,
    height,
    crop: 'fill',
    quality: 'auto',
    format: 'auto'
  });
};

// Helper function to get thumbnail URL
export const getThumbnailUrl = (publicId, size = 200) => {
  return buildCloudinaryUrl(publicId, {
    width: size,
    height: size,
    crop: 'fill',
    quality: 'auto',
    format: 'auto'
  });
};

// Helper function to get avatar URL
export const getAvatarUrl = (publicId, size = 100) => {
  return buildCloudinaryUrl(publicId, {
    width: size,
    height: size,
    crop: 'fill',
    quality: 'auto',
    format: 'auto'
  });
};

export default cloudinaryConfig;
